import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=204f241b&scoped=true&lang=css"
script.__scopeId = "data-v-204f241b"

export default script